import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { Dashboard } from './pages/Dashboard';
import { ProductCatalog } from './pages/ProductCatalog';
import { ProductDetail } from './pages/ProductDetail';
import { Messages } from './pages/Messages';
import { Profile } from './pages/Profile';
import { MainLayout } from './layouts/MainLayout';
import { AuthLayout } from './layouts/AuthLayout';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
export function AppRouter() {
  return <BrowserRouter data-id="element-1">
      <Routes data-id="element-2">
        <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
        <Route element={<AuthLayout data-id="element-6" />} data-id="element-5">
          <Route path="/login" element={<Login data-id="element-8" />} data-id="element-7" />
          <Route path="/register" element={<Register data-id="element-10" />} data-id="element-9" />
        </Route>
        <Route element={<MainLayout data-id="element-12" />} data-id="element-11">
          <Route path="/dashboard" element={<Dashboard data-id="element-14" />} data-id="element-13" />
          <Route path="/products" element={<ProductCatalog data-id="element-16" />} data-id="element-15" />
          <Route path="/products/:id" element={<ProductDetail data-id="element-18" />} data-id="element-17" />
          <Route path="/messages" element={<Messages data-id="element-20" />} data-id="element-19" />
          <Route path="/profile" element={<Profile data-id="element-22" />} data-id="element-21" />
        </Route>
      </Routes>
    </BrowserRouter>;
}